import { render, staticRenderFns } from "./CountDown.vue?vue&type=template&id=18aca71a&scoped=true"
import script from "./CountDown.vue?vue&type=script&lang=js"
export * from "./CountDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aca71a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18aca71a')) {
      api.createRecord('18aca71a', component.options)
    } else {
      api.reload('18aca71a', component.options)
    }
    module.hot.accept("./CountDown.vue?vue&type=template&id=18aca71a&scoped=true", function () {
      api.rerender('18aca71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CountDown/CountDown.vue"
export default component.exports